import React from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";

export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=org.koralove.app";
export const PLAY_BADGE_FR = "https://play.google.com/intl/fr_fr/badges/static/images/badges/fr_badge_web_generic.png";

export const PlayStoreIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 512 512" aria-hidden="true">
    <path fill="#00C4FF" d="M48 32 304 256 48 480c-10-6-16-17-16-30V62c0-13 6-24 16-30z" />
    <path fill="#FFD400" d="M48 32c6-4 14-5 22-1l266 150-32 75L48 32z" />
    <path fill="#FF3A44" d="M304 256l32 75L70 481c-8 4-16 3-22-1l256-224z" />
    <path fill="#00E07A" d="M336 181l96 54c22 12 22 30 0 42l-96 54-48-75 48-75z" />
  </svg>
);

const isAndroidMobile = () => /Android/i.test(navigator.userAgent);

export const AppBanner = () => {
  const location = useLocation();
  const [hidden, setHidden] = React.useState(() => localStorage.getItem("kora_app_banner_hide") === "1");

  if (hidden || !isAndroidMobile()) return null;
  if (location.pathname.startsWith("/auth/") || sessionStorage.getItem("kora_mobile_auth")) return null;

  const dismiss = () => {
    localStorage.setItem("kora_app_banner_hide", "1");
    setHidden(true);
  };

  return (
    <div data-testid="smart-app-banner" className="bg-kora-ink text-white px-3 py-2.5 flex items-center gap-2.5">
      <button data-testid="app-banner-close" onClick={dismiss} className="text-white/50 hover:text-white shrink-0" aria-label="Fermer">
        <X size={16} />
      </button>
      <div className="w-9 h-9 rounded-xl bg-white flex items-center justify-center shrink-0">
        <PlayStoreIcon size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-[13px] font-bold leading-tight">KoraLove est sur Play Store</p>
      </div>
      <a
        data-testid="app-banner-install"
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noreferrer"
        className="shrink-0 bg-kora-terracotta text-white text-[13px] font-bold rounded-full px-4 py-2"
      >
        Installer
      </a>
    </div>
  );
};

export default AppBanner;
